const asosKey = "asos";
const plpKey = "plp";

export const config = {
  globalKeys: {
    asosKey,
    webContextKey: `${asosKey}.webContext`,
    eventBusKey: `${asosKey}.eventBus`,
    sdkKey: `${asosKey}.sdk`,
    plpKey: `${asosKey}.${plpKey}`,
    loadableKey: `${asosKey}.${plpKey}._loadable_state`,
    loadableDefaultKey: `__LOADABLE_STATE__`,
    storeKey: `${asosKey}.${plpKey}._data`,
    configKey: `${asosKey}.${plpKey}._config`,
    pageLoadDataKey: `${asosKey}.${plpKey}._pageLoadData`
  }
};
